import {useUIStore} from './useSignlinesUIStore';

export const useAvatarEdit = () => [
    useUIStore(state => state.inEdit),
    useUIStore(state => state.setEdit),
] as const;
